export default __webpack_public_path__ + "static/media/shield_red.7c439a49.svg";